import { useEffect, useRef } from 'preact/hooks';
import type { Stats, StatsSnapshot } from '../engine/Stats';

const f1 = (n: number) => n.toFixed(1);
const f2 = (n: number) => n.toFixed(2);

function render(s: StatsSnapshot): string {
  const p = s.pointer;
  const hover = s.lastHoverAgoMs === null ? 'none yet' : `${(s.lastHoverAgoMs / 1000).toFixed(1)} s ago`;
  return [
    `sample rate        ${s.sampleHz ? f1(s.sampleHz) + ' Hz' : '–'}`,
    `coalesced / frame  avg ${f1(s.coalescedPerFrame.avg)}  max ${s.coalescedPerFrame.max}`,
    `predicted / frame  avg ${f1(s.predictedPerFrame.avg)}  max ${s.predictedPerFrame.max}`,
    `live draw / frame  avg ${f2(s.liveDrawMs.avg)} ms  max ${f2(s.liveDrawMs.max)} ms`,
    `input → drawn      avg ${f1(s.inputToDrawMs.avg)} ms  max ${f1(s.inputToDrawMs.max)} ms`,
    `tile raster        ${f1(s.rasterMs)} ms   composites ${s.compositeFps}/s   tiles ${s.tiles}`,
    `low-latency canvas ${s.desynchronized ? 'yes (desynchronized)' : 'NO'}`,
    `strokes on page    ${s.strokesOnPage}`,
    `mode               ${s.mode}`,
    `hover events       ${s.hoverEvents}  (last ${hover})  segments saved ${s.hoverSegments}`,
    p
      ? `pointer            ${p.type} p=${f2(p.pressure)} tilt=${p.tiltX},${p.tiltY} button=${p.button} buttons=${p.buttons} contact=${f1(p.width)}×${f1(p.height)}`
      : 'pointer            –',
    '',
    'pen button log (newest first):',
    ...(s.buttonLog.length ? s.buttonLog : ['  (press the side button while hovering or writing)']),
  ].join('\n');
}

/** Live metrics overlay. Updates its own DOM at 4 Hz; never re-renders through Preact. */
export function DebugPanel({ stats }: { stats: Stats }) {
  const pre = useRef<HTMLPreElement>(null);
  useEffect(() => {
    let raf = 0;
    const loop = () => { stats.tick(); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    const iv = setInterval(() => { if (pre.current) pre.current.textContent = render(stats.snapshot()); }, 250);
    return () => { cancelAnimationFrame(raf); clearInterval(iv); };
  }, [stats]);
  return <pre ref={pre} class="debug-panel" aria-live="off" />;
}
